



import Vue from 'vue'
import CurrentTemperature from '../components/current-measurements/CurrentTemperature/CurrentTemperature.vue'
import CurrentHumidity from '../components/current-measurements/CurrentHumidity/CurrentHumidity.vue'
import CurrentLight from '../components/current-measurements/CurrentLight/CurrentLight.vue'

export default Vue.extend({
  name: 'home',

  components: { CurrentTemperature, CurrentHumidity, CurrentLight },

})
